export const cronPlaces = {
  WEEKLY: 5,
  MONTHLY: 3,
  HOUR: 2,
  MIN: 1,
  SEC:0
};
